export function isPathOnlyUrl(url: string) {
  return Boolean(/^\/[^/]/.exec(url));
}
